import { Box } from "@chakra-ui/react"
import * as React from "react"
import { useRecoilValue, useRecoilState } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { localUserIdAtom, usersSelector } from "../../../recoil/atoms/users"
import { MobileView } from "./mobile-view/MobileView"
import type { DevicesLists } from "../../settings/settings.interfaces"
import { settingsDevicesSelector } from "../../../recoil/atoms/settings"
import { useBoolean } from "../../../hooks/useBoolean"
import { ConsoleLogger } from "../../../util/logger"

const LSRTC = window.LSRTC
const UserType = window.MeetOnline?.UserType
const logger = new ConsoleLogger()

const SmallView = () => {
  const roomStyles = useRecoilValue(brandingSelector)
  const _localUserId = useRecoilValue(localUserIdAtom)
  const localUser = useRecoilValue(usersSelector(_localUserId))
  const [isLoadedDevices, { on: setIsLoadedDevices }] = useBoolean(false)
  const [devicesLists, setDevicesLists] = React.useState<DevicesLists>({
    video: [],
    audio: []
  })
  const [savedDevices, setSavedDevices] = useRecoilState(
    settingsDevicesSelector
  )

  const setLists = React.useCallback(async () => {
    const devices = await LSRTC?.getDevices?.()

    if(!devices) return

    const microphones = devices.filter(function (device) {
      return device.kind === "audioinput"
    })
    const cameras = devices.filter(function (device) {
      return device.kind === "videoinput"
    })

    const transformedMicrophones = microphones.map(micro => ({
      id: micro.deviceId,
      label: micro.label
    }))
    const transformedCameras = cameras.map(cam => ({
      id: cam.deviceId,
      label: cam.label
    }))

    setDevicesLists({
      video: transformedCameras,
      audio: transformedMicrophones
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LSRTC])

  const requestUserMediaPermissions = React.useCallback(async () => {
    if (isLoadedDevices) return

    try {
      await setLists()

      setIsLoadedDevices()
    } catch (error) {
      logger.error(error)
    }
  }, [setLists, isLoadedDevices, setIsLoadedDevices])

  const setDefaultDevices = React.useCallback(() => {
    if (devicesLists.video.length === 0 || devicesLists.audio.length === 0)
      return

    if (!savedDevices.video && !savedDevices.audio) {
      setSavedDevices({
        video: devicesLists.video[0],
        audio: devicesLists.audio[0]
      })
    }
  }, [savedDevices, devicesLists, setSavedDevices])

  React.useEffect(() => {
    if (localUser?.type === UserType?.AUDIENCE) {
    } else {
      requestUserMediaPermissions()
    }
  }, [requestUserMediaPermissions, localUser])

  React.useEffect(() => {
    if (isLoadedDevices) {
      setDefaultDevices()
    }
  }, [setDefaultDevices, isLoadedDevices])

  return (
    <Box
      bgImage={
        roomStyles?.roomBackgroundImage
          ? `url(${roomStyles.roomBackgroundImage})`
          : "none"
      }
      width="100%"
    >
      <MobileView />
    </Box>
  )
}
export default SmallView
